/* read-more-button.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./read-more-button.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Pressable, Text } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onReadMoreButtonClicked, onReadMoreButtonShown } from '../../../ai-answer-dialog/analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../../common/controller/analytics/use-analytics';
import { messages } from './messages';
var styles = {
  container: "_18zrpxbi _1e0c1txw _ca0q12x7",
  readMoreButton: "_18zrze3t _k48p1wq8 _syaz13af _bfhksm61 _o5721q9c _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h12zz"
};
export function ReadMoreButton(_ref) {
  var onClick = _ref.onClick;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;

  // Fire analytics event when button is shown
  useEffect(function () {
    fireAnalyticsEvent(onReadMoreButtonShown(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle click with analytics
  var handleClick = useCallback(function () {
    fireAnalyticsEvent(onReadMoreButtonClicked(commonAttributes));
    if (!fg('kd_fix_sain_mau_instrumentation')) {
      fireSAINUsageEvent({
        metCriteria: SainAction.READ_MORE_BUTTON_CLICKED,
        commonAttributes: commonAttributes
      });
    }
    onClick();
  }, [fireAnalyticsEvent, onClick, commonAttributes, fireSAINUsageEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement(Pressable, {
    onClick: handleClick,
    xcss: styles.readMoreButton,
    testId: "read-more-button"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    color: "color.link"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_card_read_more_button))));
}